import type { BrandConcessionContentSectionDTO } from '~gateways/ownable.dtos';

type HeroAndTextSubtype = 'HeroAndText' | 'HeroNoText' | 'NoHeroText';

export function getHeroAndTextSubtype(
  section: BrandConcessionContentSectionDTO
): HeroAndTextSubtype {
  if (isHeroOnly(section)) {
    return 'HeroNoText';
  }
  if (isTextOnly(section)) {
    return 'NoHeroText';
  }
  return 'HeroAndText';
}

function isHeroOnly(section: BrandConcessionContentSectionDTO) {
  return (
    section.heroImageUrl &&
    !section.title &&
    !section.text &&
    !section.linkButtonTitle
  );
}

function isTextOnly(section: BrandConcessionContentSectionDTO) {
  return (
    !section.heroImageUrl &&
    (section.title || section.text || section.linkButtonTitle)
  );
}
